module.exports = __webpack_public_path__ + "img/00043.4ea0630e.webp";